import React, { useState } from 'react';
import Container from '../../../components/UI/Container';
import { enFr, getLang } from '../../../utils';
import { fixImagePaths } from '../../../utils/image-helpers';
import AICaseStudiesWrapper from './aiCaseStudies.style';

import awakenData from '../../../assets/data/awaken/index.json';
import awakenFrenchData from '../../../assets/data/awaken-french/index.json';

const AICaseStudies = () => {
  const lang = getLang();
  const localizedData = fixImagePaths(lang === 'fr' ? awakenFrenchData : awakenData);
  const caseStudies = localizedData.AI_CASE_STUDIES || awakenData.AI_CASE_STUDIES;
  const [activeIndex, setActiveIndex] = useState(0);

  return (
    <AICaseStudiesWrapper id="case-studies">
      <Container>
        <div className="section-header">
          <h2>{enFr('Case Studies', 'Études de cas')}</h2>
          <p className="section-subtitle">
            {enFr(
              'Real-world engagements demonstrating measurable impact through strategic technology and AI adoption.',
              'Engagements concrets démontrant un impact mesurable grâce à l\u2019adoption stratégique de la technologie et de l\u2019IA.'
            )}
          </p>
        </div>

        <div className="case-study-nav">
          {caseStudies.map((cs, index) => (
            <button
              key={index}
              className={`nav-tab ${activeIndex === index ? 'active' : ''}`}
              onClick={() => setActiveIndex(index)}
              type="button"
            >
              {cs.title}
            </button>
          ))}
        </div>

        {caseStudies.map((cs, index) => (
          activeIndex === index && (
            <div className="case-study-content" key={index}>
              <div className="cs-header">
                <span className="cs-subtitle">{cs.subtitle}</span>
                <h3>{cs.title}</h3>
              </div>

              <div className="cs-body">
                <div className="cs-section">
                  <h4>{enFr('Challenge', 'Défi')}</h4>
                  <p>{cs.challenge}</p>
                </div>
                <div className="cs-section">
                  <h4>{enFr('Approach', 'Approche')}</h4>
                  <p>{cs.approach}</p>
                </div>
                <div className="cs-section results">
                  <h4>{enFr('Results', 'Résultats')}</h4>
                  <ul>
                    {cs.results.map((result, i) => (
                      <li key={i}>
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#f16600" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                          <polyline points="20 6 9 17 4 12" />
                        </svg>
                        <span>{result}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>

              <div className="cs-technologies">
                {cs.technologies.map((tech, i) => (
                  <span className="tech-tag" key={i}>{tech}</span>
                ))}
              </div>
            </div>
          )
        ))}
      </Container>
    </AICaseStudiesWrapper>
  );
};

export default AICaseStudies;
